export default "__VITE_ASSET__DNc5UWnV__"